import { render, staticRenderFns } from "./ModalAddress.vue?vue&type=template&id=0e447a23&scoped=true"
import script from "./ModalAddress.vue?vue&type=script&lang=js"
export * from "./ModalAddress.vue?vue&type=script&lang=js"
import style0 from "./ModalAddress.vue?vue&type=style&index=0&id=0e447a23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e447a23",
  null
  
)

export default component.exports